import { useEffect, useState } from "react";

/** Returns whether `window.matchMedia(query).matches` (false during SSR / first paint). */
export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.matchMedia(query).matches;
    });

    useEffect(() => {
        const m = window.matchMedia(query);
        const onChange = () => setMatches(m.matches);
        setMatches(m.matches);
        m.addEventListener("change", onChange);
        return () => m.removeEventListener("change", onChange);
    }, [query]);

    return matches;
}
